const t = "button", n = "button__content", o = "button__text", u = {
  button: t,
  "button__icon-container": "button__icon-container",
  "button__icon-container--loading": "button__icon-container--loading",
  "loading-spinner": "loading-spinner",
  button__content: n,
  "button__content--loading": "button__content--loading",
  "button__loading-spinner": "button__loading-spinner",
  button__text: o,
  "button__visually-hidden": "button__visually-hidden",
  "button--size-small": "button--size-small",
  "button--loading": "button--loading",
  "button--left-aligned": "button--left-aligned",
  "button--primary": "button--primary",
  "button--disabled": "button--disabled",
  "button--secondary": "button--secondary",
  "button--tertiary": "button--tertiary",
  "button--success": "button--success",
  "button--error": "button--error",
  "button--bottom-fixed": "button--bottom-fixed",
  "button-wrapper": "button-wrapper",
  "button-wrapper--no-margin": "button-wrapper--no-margin"
};
export {
  t as button,
  n as button__content,
  o as button__text,
  u as default
};
